import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../shared/app.constants';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';
var CandidateService = /** @class */ (function () {
    function CandidateService(auth, appConstants, http) {
        this.auth = auth;
        this.appConstants = appConstants;
        this.http = http;
    }
    CandidateService.prototype.getAllCandidates = function () {
        var url = environment.apiBase + 'candidates';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    CandidateService.prototype.getCandidate = function (candidateId) {
        var url = environment.apiBase + ("candidates/" + candidateId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    CandidateService.prototype.deleteCandidate = function (candidateId) {
        var url = environment.apiBase + ("candidates/" + candidateId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.delete(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return CandidateService;
}());
export { CandidateService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/candidate.service.ts.pre-build-optimizer.js